import React from "react";
import Hero from "@/components/sections/Hero";
import Stats from "@/components/sections/Stats";
import Exams from "@/components/sections/Exams";
import Features from "@/components/sections/Features";
import Subjects from "@/components/sections/Subjects";
import HowItWorks from "@/components/sections/HowItWorks";
import Pricing from "@/components/sections/Pricing";
import Referral from "@/components/sections/Referral";
import Testimonials from "@/components/sections/Testimonials";
import FAQ from "@/components/sections/FAQ";
import FinalCTA from "@/components/sections/FinalCTA";

const Home = () => {
  return (
    <main data-testid="home-page">
      <Hero />
      <Stats />
      <Exams />
      <Features />
      <Subjects />
      <HowItWorks />
      <Pricing />
      <Referral />
      <Testimonials />
      <FAQ />
      <FinalCTA />
    </main>
  );
};

export default Home;
